import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserLimitsResponse {
  can_create: {
    invoice: boolean;
    client: boolean;
    estimate: boolean;
  };
}

export interface UserLimitsState {
  hasFetched: boolean;
  isLoading: boolean;
  error: string | null;
  canCreateInvoice: boolean;
  canCreateClient: boolean;
  canCreateEstimate: boolean;
}

export const userLimitsState: UserLimitsState = {
  hasFetched: false,
  isLoading: false,
  error: null,
  canCreateInvoice: true,
  canCreateClient: true,
  canCreateEstimate: true,
};

export const userLimitsSlice = createSlice({
  name: 'userLimits',
  initialState: userLimitsState,
  reducers: {
    fetchUserLimitsStart: draft => {
      draft.isLoading = true;
      draft.error = null;
    },
    fetchUserLimitsSuccess: (
      draft,
      action: PayloadAction<{ invoice: boolean; client: boolean; estimate: boolean }>,
    ) => {
      draft.hasFetched = true;
      draft.isLoading = false;
      draft.canCreateInvoice = action.payload.invoice;
      draft.canCreateClient = action.payload.client;
      draft.canCreateEstimate = action.payload.estimate;
    },
    fetchUserLimitsFailure: (draft, action: PayloadAction<string>) => {
      draft.isLoading = false;
      draft.error = action.payload;
    },
    clearUserLimits: () => userLimitsState,
  },
});

export const {
  fetchUserLimitsStart,
  fetchUserLimitsSuccess,
  fetchUserLimitsFailure,
  clearUserLimits,
} = userLimitsSlice.actions;

export default userLimitsSlice.reducer;
